/* DIPSET — storefront behaviour. Deferred. No dependencies. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cfg = window.theme || {};

  /* ---------- money ----------
     Currency comes from Shopify's own runtime object (set by content_for_header,
     follows Markets if it is ever turned on), with the Liquid-injected value as
     the fallback. Amounts from cart.js are in minor units. */
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cfg.currency || 'USD';
  var fmt;
  try { fmt = new Intl.NumberFormat(cfg.locale || 'en', { style: 'currency', currency: currency }); }
  catch (err) { fmt = null; }
  function money(cents) {
    var n = (cents || 0) / 100;
    return fmt ? fmt.format(n) : '$' + n.toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Shopify CDN images take width as a query parameter */
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- elements ---------- */
  var drawer = document.getElementById('CartDrawer');
  var itemsEl = document.getElementById('CartItems');
  var footEl = document.getElementById('CartFoot');
  var totalEl = document.getElementById('CartTotal');
  var mnav = document.getElementById('MobileNav');
  var lastFocus = null;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function setExpanded(selector, on) {
    document.querySelectorAll(selector).forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- cart drawer ---------- */
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="drawer__empty mono">Your bag is empty</p>';
      if (footEl) footEl.hidden = true;
      return;
    }
    if (footEl) footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(function (i) {
      var img = i.image
        ? '<img src="' + esc(sized(i.image, 200)) + '" alt="" width="66" height="76" loading="lazy">'
        : '<div style="width:66px;aspect-ratio:1;background:var(--surface)"></div>';
      var opt = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      var key = esc(i.key);
      return '<div class="citem">' + img +
        '<div class="citem__b">' +
          '<p class="citem__n"><a href="' + esc(i.url) + '">' + esc(i.product_title) + '</a></p>' +
          (opt ? '<p class="mono citem__v">' + esc(opt) + '</p>' : '') +
          '<p class="price" style="margin:0">' + money(i.final_line_price) + '</p>' +
          '<div style="display:flex;gap:10px;align-items:center;margin-top:8px">' +
            '<button class="hdr__btn" type="button" data-qty data-key="' + key + '" data-to="' + (i.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(i.product_title) + '">&minus;</button>' +
            '<span class="mono" style="min-width:18px;text-align:center" aria-live="polite">' + i.quantity + '</span>' +
            '<button class="hdr__btn" type="button" data-qty data-key="' + key + '" data-to="' + (i.quantity + 1) + '" aria-label="Increase quantity of ' + esc(i.product_title) + '">+</button>' +
            '<button class="hdr__btn" type="button" style="margin-left:auto" data-qty data-key="' + key + '" data-to="0" aria-label="Remove ' + esc(i.product_title) + '">Remove</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function cartError(msg) {
    if (!itemsEl) return;
    var p = itemsEl.querySelector('.drawer__err');
    if (!p) { p = document.createElement('p'); p.className = 'mono drawer__err'; itemsEl.prepend(p); }
    p.textContent = msg;
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) { renderCart(c); return c; })
      .catch(function () { cartError('Could not load your bag. Refresh to try again.'); });
  }

  function trapTab(container, e) {
    var items = Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setExpanded('[data-cart-open]', true);
    document.body.style.overflow = 'hidden';
    var c = drawer.querySelector('.drawer__close');
    if (c) c.focus();
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    setExpanded('[data-cart-open]', false);
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openMenu() {
    if (!mnav) return;
    lastFocus = document.activeElement;
    mnav.classList.add('is-open');
    mnav.setAttribute('aria-hidden', 'false');
    setExpanded('[data-menu-open]', true);
    document.body.style.overflow = 'hidden';
    var mc = mnav.querySelector('[data-menu-close]');
    if (mc) mc.focus();
  }

  function closeMenu() {
    if (!mnav || !mnav.classList.contains('is-open')) return;
    mnav.classList.remove('is-open');
    mnav.setAttribute('aria-hidden', 'true');
    setExpanded('[data-menu-open]', false);
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); fetchCart().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]') || e.target === drawer) { closeDrawer(); return; }
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }

    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      q.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: q.dataset.key, quantity: parseInt(q.dataset.to, 10) })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(renderCart)
        .catch(function () { q.disabled = false; cartError('Could not update that item. Try again.'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); return; }
    if (e.key === 'Tab') {
      if (drawer && drawer.classList.contains('is-open')) trapTab(drawer, e);
      else if (mnav && mnav.classList.contains('is-open')) trapTab(mnav, e);
    }
  });

  /* ---------- add to bag ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var note = form.querySelector('[data-form-note]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { if (note) note.textContent = res.d.description || res.d.message || 'Could not add that one.'; return; }
        if (note) note.textContent = '';
        return fetchCart().then(openDrawer);
      })
      .catch(function () { if (note) note.textContent = 'Network error. Try again.'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- variant picker ----------
     The URL only changes after the shopper picks something; the initial
     render leaves the canonical product URL alone. */
  document.querySelectorAll('[data-variants]').forEach(function (scope) {
    var holder = scope.querySelector('[data-variant-json]');
    if (!holder) return;
    var data;
    try { data = JSON.parse(holder.textContent); } catch (err) { return; }
    var idInput = scope.querySelector('input[name="id"]');
    var priceEl = scope.querySelector('[data-price]');
    var btn = scope.querySelector('[type="submit"]');
    var note = scope.querySelector('[data-form-note]');

    function update(fromUser) {
      var chosen = Array.prototype.map.call(
        scope.querySelectorAll('input[type="radio"]:checked'),
        function (i) { return i.value; }
      );
      if (!chosen.length) return;
      var match = null;
      for (var k = 0; k < data.length; k++) {
        var hit = true;
        for (var j = 0; j < chosen.length; j++) {
          if (data[k].options[j] !== chosen[j]) { hit = false; break; }
        }
        if (hit) { match = data[k]; break; }
      }
      if (!match) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = (match.compare > match.price)
          ? '<s>' + money(match.compare) + '</s> ' + money(match.price)
          : money(match.price);
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.dataset.label : 'Sold out';
      }
      if (note) note.textContent = '';
      if (fromUser && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u);
      }
    }

    scope.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update(true);
    });
    update(false);
  });

  /* ---------- gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.full;
        main.srcset = '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', o === t ? 'true' : 'false');
        });
      });
    });
  });

  /* back/forward cache: the bag may have changed on another page */
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });
})();
